import React, { useEffect, useState } from "react";
import "./order.css";
import { getOrderById, getProductById } from "../../services/auth/User";
import Loader2 from "../../components/Loader2";
import toast from "react-hot-toast";

function Orders() {
  const [userData, setUserData] = useState(null);
  const [isPending, setIsPending] = useState(false);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    const storedUser = localStorage.getItem("userData");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setUserData(parsedUser);
    }
  }, []);

  useEffect(() => {
    if (userData && userData.user && userData.user._id) {
      fetchOrders();
    }
  }, [userData]);

  const fetchOrders = async () => {
    setIsPending(true);
    try {
      const response = await getOrderById(userData.user._id);
      const allOrders = response.orders;

      for (let i = 0; i < allOrders.length; i++) {
        const element = allOrders[i];

        // Fetch product details for each productId in orderItems
        const orderItemsWithDetails = await Promise.all(
          element.orderItems.map(async (item) => {
            const productDetails = await getProductById(item.productId);
            return { ...item, productDetails };
          })
        );

        element.orderItems = orderItemsWithDetails;
      }
      setOrders(allOrders);
    } catch (error) {
      console.error("Failed to fetch orders:", error);
    } finally {
      setIsPending(false);
    }
  };

  return (
    <>
      {isPending ? (
        <Loader2 />
      ) : (
        <div className="orders">
          <h1>Your Orders</h1>
          {orders.length === 0 ? (
            <p>No orders found</p>
          ) : (
            <div className="orders-flex">
              {orders.map((order) => (
                <div className="orders-list" key={order._id}>
                  <li>
                    <div className="order-details">
                      <h2>Order ID: {order._id}</h2>
                      <h2
                      style={{
                        color:
                          order.orderStatus === "Ordered" || order.orderStatus === "Processing"
                            ? "orange"
                            : order.orderStatus === "Completed"
                            ? "green"
                            : order.orderStatus === "Cancelled"
                            ? "red"
                            : "black", // Default color
                        fontWeight: "bold",
                      }}
                      
                      >
                        Status:{" "}
                        {order.orderStatus === "Ordered" ||
                        order.orderStatus === "Processing"
                          ? `To be Delivered on ${new Date(
                              order.estimatedDelivery
                            ).toLocaleDateString("en-GB")}`
                          : order.orderStatus === "Completed"
                          ? "Delivered"
                          : order.orderStatus === "Cancelled"
                          ? "Cancelled"
                          : "Delivered"}
                      </h2>

                      <h2 className="order-price">
                        Total Amount: <span>Rs. {order.totalAmount}</span>
                      </h2>
                    </div>

                    {/* Dynamically Rendering Order Items */}
                    {order.orderItems.map((item) => (
                      <div className="order-item" key={item._id}>
                        <img
                          src={
                            item.productDetails?.imageSrc[0] ||
                            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRHICWZcFeQ7UuaU7N30-E4Vt1GaTYIU1DIEA&s"
                          }
                          alt={item.productDetails?.title || "N/A"}
                        />
                        <div className="order-item-details">
                          <h2>{item.productDetails?.title || "N/A"}</h2>
                          <p>
                            Rs. {item.sellingPrice || "N/A"} x {item.quantity}
                          </p>
                        </div>
                      </div>
                    ))}
                  </li>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default Orders;
